import React from 'react'
import { ReactComponent as CaretDown } from "../../svg/caret-down.svg";
import { ReactComponent as Check } from "../../svg/check.svg";

class Dropdown extends React.Component {

  handleClick(value){
    this.props.onClick(value)
  }

  getDropdownOption(option){
    const isSelected = option.selected || option.active
    const disabled = option.disabled
    let cn = isSelected && !disabled ? 'custom-dropdown__option selected' : 'custom-dropdown__option'
    if(disabled){
      cn = 'custom-dropdown__option disabled'
    }
    if(option.className){
      cn += ` ${option.className}`
    }
    if(option.type === 'title'){
      return (
        <div className={cn}>
          <span className='custom-dropdown__option__title'>
            {option.title}
          </span>
        </div>
      )
    }
    return (
      <div 
        className={cn}
        onClick={() => disabled ? undefined : this.handleClick(option.value)}
      >
        <span className='custom-dropdown__option__value'>
          {option.title || option.value}
          {isSelected ? <Check className='option-check' /> : undefined}
        </span>
      </div>
    )
  }

  getActiveOption(options){
    const active = options.find(({ selected }) => selected)
    const { title } = this.props
    return (
      <div className='custom-dropdown__active-option' onClick={this.props.toggle}>
        {
          title ? (
            <span className='custom-dropdown__active-option__title'>
              {title + ' '}
            </span>
          )
          :
          undefined
        }
        <span className='custom-dropdown__active-option__value'>
          {active.title}
        </span>
          {this.props.caret ? <CaretDown /> : undefined}
      </div>
    )
  }

  render(){
    const { isOpen, options, className, title, customStyle } = this.props
    const style = {
      display: isOpen ? 'block' : 'none'
    }
    return (
      <div className={`custom-dropdown ${className}`}>
        {this.getActiveOption(options)}
        {
          isOpen ? (
            <div className='custom-dropdown__options' style={customStyle || {}}>
              {
                options.map((opt, idx) => (
                  <React.Fragment key={idx}>
                    {this.getDropdownOption(opt)}
                  </React.Fragment>
                ))
              }
            </div>
          )
          :
          undefined
        }
      </div>
    )
  }

}

export default Dropdown